import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/20/solid';
import { CircularProgress } from '../core/circular_progress';

interface OperationStateBadgeProps {
  state: string;
}

export function OperationStateBadge(props: OperationStateBadgeProps) {
  return (
    <span className="flex items-center text-sm text-gray-500">
      {props.state == 'Running' && (
        <CircularProgress className="mr-2 ml-0.5 h-4 w-4 animate-spin text-blue-500" />
      )}
      {props.state === 'Succeeded' && (
        <CheckCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-400"
          aria-hidden="true"
        />
      )}
      {props.state === 'Failed' && (
        <ExclamationCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-red-400"
          aria-hidden="true"
        />
      )}
      {props.state}
    </span>
  );
}
